import {
  ColumnHeader,
  EarmarkDTO,
  EarmarkOptionDTO,
  OtherAssetType,
  OwnerModelDTO,
  OwnerOptionsDTO,
} from '../../OtherAssets.meta';

export const columnHeaders: ColumnHeader[] = [
  { text: 'Name' },
  { text: 'Value', align: 'right' },
  { text: 'Balance', align: 'right' },
  { text: 'Monthly Payment', align: 'right' },
];

export enum RealEstateInvestmentType {
  Personal,
  Investment,
}

export enum MortgageType {
  Fixed30Y,
  Fixed15Y,
  Arm10Y,
  Arm5Y,
  Arm1Y,
  InterestOnly,
  Fixed10Y,
  Fixed20Y,
  Fixed25Y,
  Fixed40Y,
}

export interface RealEstateDTO {
  Id: string;
  Name: string;
  MarketValue: number | null;
  InvestmentType: RealEstateInvestmentType | null;
  PropertyTaxPerYear: number | null;
  HomeInsurancePerYear: number | null;
  MonthlyHoa: number | null;
  Owner: string;
  MortgageId: string | null;
  MortgageOutstandingBalance: number | null;
  MortgageOriginationDate: string | null;
  MortgageType: MortgageType | null;
  MortgageMonthlyPayment: number | null;
  MortgageInstitutionId: number | null;
  MortgageInstitutionName: string | null;
  MortgageMonthlyPmi: number | null;
  YearlyRentalIncome: number | null;
  SaleYear: number | null;
  IsSoldAtRetirement: boolean | null;
  SaleNetEarnings: number | null;
  IncomeGrowth: number | null;
  MortgageInterestRate: number | null;
  AssetEarmark: EarmarkDTO[];
  AssetGrowth: number;
  MortgageExcludeFromDebtManagementGoal: boolean;
  OtherAssetType: OtherAssetType;
  CustomBucketIndex: number | null;
  IsExcludedFromAssetBucketing: boolean;
  IsLiquid: boolean;
  IncludeInGrossEstate: boolean;
  OrionManagementStyleId: number | null;
  OwnerModel: OwnerModelDTO[];
  isClone?: boolean;
}

interface MortgageDTO {
  MortgageLabel: string;
  MortgageId: string;
  MortgageType: MortgageType;
  MortgageOriginationDate: string | null;
  MortgageInterestRate: number | null;
  MortgageMonthlyPmi: number | null;
  MortgageOutstandingBalance: number | null;
  MortgageMonthlyPayment: number;
  MortgageInstitutionId: number;
  MortgageInstitutionName: string;
  MortgageIsLinked: boolean;
  MortgageExcludeFromDebtManagementGoal: boolean;
  OrionManagementStyleId: number | null;
}

export interface RealEstateOptionsDTO {
  ownerOptions: OwnerOptionsDTO;
  investmentTypeOptions: {
    label: string;
    value: RealEstateInvestmentType;
  }[];
  mortgageTypeOptions: {
    label: string;
    value: MortgageType;
  }[];
  AllowUnequalOwnership: boolean;
  SaleYearOptions: string[];
  ExistingMortgages: MortgageDTO[];
  EarmarkOptions: EarmarkOptionDTO[];
  ShowExcludeFromDebtManagementGoal: boolean;
  DefaultAssetBucketIndices: { Personal: number | null; Investment: number | null };
  IsLiquid: boolean;
}
